import i18next from 'i18next'
import XHR from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18next
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/locales/{{lng}}.json`,
    },
    react: {
      useSuspense: false,
    },
    fallbackLng: 'en',
    preload: ['zh-CN'],
    keySeparator: false,
    interpolation: { escapeValue: false },
  })

export default i18next
